import { render } from "./wokerDetail5.vue?vue&type=template&id=06f3d194&scoped=true"
import script from "./wokerDetail5.vue?vue&type=script&lang=js"
export * from "./wokerDetail5.vue?vue&type=script&lang=js"

import "./wokerDetail5.vue?vue&type=style&index=0&id=06f3d194&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06f3d194"]])

export default __exports__